import { TuiButtonModule } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogRef, DialogService } from '@ngneat/dialog';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Component, Inject } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';

import { ImpersonateService } from '../impersonate.service';

import {
  ControlStatusDirective,
  FormFieldComponent,
  FormFieldErrorDirective,
  InputDirective,
  LabelDirective,
} from '@iss/core/forms';

@Component({
  selector: 'wo-impersonate-dialog',
  templateUrl: './impersonate-dialog.component.html',
  styleUrls: [ './impersonate-dialog.component.scss' ],
  standalone: true,
  imports: [
    ControlStatusDirective,
    FormFieldComponent,
    FormFieldErrorDirective,
    FormsModule,
    InputDirective,
    LabelDirective,
    NgClass,
    NgIf,
    ReactiveFormsModule,
    TranslateModule,
    TuiButtonModule,
  ],
})
export class ImpersonateDialogComponent {

  public readonly impersonateId = new FormControl(this.impersonateService.getImpersonateId(), {  validators: Validators.required });

  public constructor(
    private readonly impersonateService: ImpersonateService,
    @Inject(DialogRef) private readonly ref: DialogRef<ImpersonateDialogComponent>) {
  }

  public static open(dialog: DialogService): DialogRef {
    return dialog.open(ImpersonateDialogComponent, { closeButton: false });
  }

  public closeDialog(): void {
    this.ref.close();
  }

  public async setImpersonateId(): Promise<void> {
    if (this.impersonateId.value) {
      await this.impersonateService.setImpersonateId(this.impersonateId.value);
    }
    this.closeDialog();
  }
}
